export const getNameAbbreviation = (name?: string) => {
  if (!name) {
    return;
  }

  // Split the name into an array of names by space
  const namesArray = name.split(" ");

  // If the name contains only one name
  if (namesArray.length === 1) {
    return namesArray[0].charAt(0).toUpperCase();
  }
  // If the name contains more than one name, just take the first two names
  else if (namesArray.length >= 2) {
    return (
      namesArray[0].charAt(0).toUpperCase() +
      namesArray[1].charAt(0).toUpperCase()
    );
  }

  // If the name is empty or invalid, return nothing
  return;
};
